module.exports = __webpack_public_path__ + "img/widget_career.cc441ce3.png";